import { OrganizationView } from "../../views/organizations/organization.view";
import CreativePreferences from "../../views/proposals/creativePreferences/creativePreferences";
import ProposalRevisionTimeline from "../../views/proposals/revisionTimeline/proposalRevisionTimeline";

export const ProposalFlow: JSX.Element[] = [
  <OrganizationView />,
  <CreativePreferences />,
  <ProposalRevisionTimeline />,
];
